import {Component} from "@angular/core";
import {ModalService} from "../../../shared/modal/modal.service";

@Component({
  templateUrl: './debug.modal.template.html'
})

export class DebugModalComponent extends ModalService implements IModalService {
}
